import { AnnualOrderedCapacityType } from '@/features/annualOrderedCapacities/types';

export const MONTHS_UA = <const>[
  'січень',
  'лютий',
  'березень',
  'квітень',
  'травень',
  'червень',
  'липень',
  'серпень',
  'вересень',
  'жовтень',
  'листопад',
  'грудень',
];

export const MONTHS_EN = <const>[
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

export const MONTHS_RECORD: Record<(typeof MONTHS_EN)[number], (typeof MONTHS_UA)[number]> = {
  january: 'січень',
  february: 'лютий',
  march: 'березень',
  april: 'квітень',
  may: 'травень',
  june: 'червень',
  july: 'липень',
  august: 'серпень',
  september: 'вересень',
  october: 'жовтень',
  november: 'листопад',
  december: 'грудень',
};

export const adjustmentsByOrderedCapacityType = {
    [AnnualOrderedCapacityType.CalculatedByDefault]: [
        AnnualOrderedCapacityType.FirstAdjustmentOfCalculatedByDefault,
    ],
    [AnnualOrderedCapacityType.NewCounterparty]: [
        AnnualOrderedCapacityType.FirstAdjustmentOfNewCounterparty,
        AnnualOrderedCapacityType.SecondAdjustmentOfNewCounterparty
    ],
    [AnnualOrderedCapacityType.NewMeteringPoint]: [
        AnnualOrderedCapacityType.FirstAdjustmentOfNewMeteringPoint,
        AnnualOrderedCapacityType.SecondAdjustmentOfNewMeteringPoint
    ],
    [AnnualOrderedCapacityType.FirstAdjustmentOfCalculatedByDefault]:[
        AnnualOrderedCapacityType.SecondAdjustmentOfCalculatedByDefault
    ],
    [AnnualOrderedCapacityType.FirstAdjustmentOfNewCounterparty]: [
        AnnualOrderedCapacityType.SecondAdjustmentOfNewCounterparty
    ],
    [AnnualOrderedCapacityType.FirstAdjustmentOfNewMeteringPoint]: [
        AnnualOrderedCapacityType.SecondAdjustmentOfNewMeteringPoint
    ]
}

export const adjustmentFirstTypes = [
    AnnualOrderedCapacityType.FirstAdjustmentOfCalculatedByDefault,
    AnnualOrderedCapacityType.FirstAdjustmentOfNewCounterparty,
    AnnualOrderedCapacityType.FirstAdjustmentOfNewMeteringPoint
]

export const adjustmentSecondTypes = [
    AnnualOrderedCapacityType.SecondAdjustmentOfCalculatedByDefault,
    AnnualOrderedCapacityType.SecondAdjustmentOfNewCounterparty,
    AnnualOrderedCapacityType.SecondAdjustmentOfNewMeteringPoint
]

export const adjustmentTypes = [...new Set(Object.values(adjustmentsByOrderedCapacityType).flat())]
